<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="0 0 560 560"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        id="galaxia-logo-cyan"
        x1="0%"
        y1="0%"
        x2="100%"
        y2="100%"
      >
        <stop offset="0%" stop-color="#00D0FF" />
        <stop offset="100%" stop-color="#00A3E8" />
      </linearGradient>
      <linearGradient
        id="galaxia-logo-purple"
        x1="100%"
        y1="100%"
        x2="0%"
        y2="0%"
      >
        <stop offset="0%" stop-color="#6348EB" />
        <stop offset="100%" stop-color="#3B00E0" />
      </linearGradient>
      <radialGradient id="galaxia-logo-core">
        <stop offset="0%" stop-color="#E8FBFF" />
        <stop offset="45%" stop-color="#00D0FF" />
        <stop offset="100%" stop-color="#3B00E0" />
      </radialGradient>
    </defs>
    <g transform="translate(280,280)">
      <g>
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="-18"
          to="342"
          dur="8s"
          repeatCount="indefinite"
        />
        <path
          d="M 0 -218 A 218 218 0 0 1 218 0"
          stroke="url(#galaxia-logo-cyan)"
          stroke-width="52"
          stroke-linecap="round"
        />
        <path
          d="M 0 218 A 218 218 0 0 1 -218 0"
          stroke="url(#galaxia-logo-purple)"
          stroke-width="52"
          stroke-linecap="round"
        />
      </g>
      <g>
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="-18"
          to="-378"
          dur="5s"
          repeatCount="indefinite"
        />
        <path
          d="M 138 0 A 138 138 0 0 1 0 138"
          stroke="url(#galaxia-logo-cyan)"
          stroke-width="44"
          stroke-linecap="round"
          opacity="0.85"
        />
        <path
          d="M -138 0 A 138 138 0 0 1 0 -138"
          stroke="url(#galaxia-logo-purple)"
          stroke-width="44"
          stroke-linecap="round"
          opacity="0.85"
        />
      </g>
      <g transform="rotate(-18)">
        <circle cx="0" cy="0" r="84" fill="url(#galaxia-logo-core)" opacity="0.22">
          <animate
            attributeName="opacity"
            values="0.12;0.4;0.12"
            dur="2s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="r"
            values="78;92;78"
            dur="2s"
            repeatCount="indefinite"
          />
        </circle>
        <circle cx="0" cy="0" r="62" fill="url(#galaxia-logo-core)">
          <animate
            attributeName="r"
            values="62;67;62"
            dur="2s"
            repeatCount="indefinite"
          />
        </circle>
        <path
          transform="translate(196,-196)"
          d="M 0 -46 C 6 -14 14 -6 46 0 C 14 6 6 14 0 46 C -6 14 -14 6 -46 0 C -14 -6 -6 -14 0 -46 Z"
          fill="#00D0FF"
        >
          <animate
            attributeName="opacity"
            values="1;0.3;1"
            dur="2.4s"
            repeatCount="indefinite"
          />
        </path>
      </g>
    </g>
  </svg>
</template>
